export const OrganizationQueryKey = 'organizations';
export const TransactionQueryKey = 'transactions';
export const TransactionPOSQueryKey = 'transactions-pos';
export const CryptoDepositPostQueryKey = 'crypto-deposits';
export const GroupQueryKey = 'groups';
export const ContentTypeQueryKey = 'content-type';
export const BankAccountQueryKey = 'bank-account';
export const CryptoAccountQueryKey = 'crypto-account';
export const ContactSubmitQueryKey = 'contact-submit';
export const CryptoDepositQueryKey = 'crypto-deposit';
export const BankFileQueryKey = 'bank-file';
export const CoPQueryKey = 'USERS';
export const BusinessFileQueryKey = 'business-file';
export const CurrencyQueryKey = 'currency';
export const CryptoDataQueryKey = 'crypto-data'
export const DefaultFeeQueryKey = 'default-fee';
export const UsersQueryKey = 'users';
export const UserClientsQueryKey = 'user-clients';
export const InboxQueryKey = 'inbox';
export const InboxUnreadQueryKey = 'inbox-unread';
export const KYCQueryKey = 'kyc';
export const PendingBalanceQueryKey = 'balance/pending';
export const BalanceQueryKey = 'balance'
export const StatisticsQueryKey = 'statistics';
export const IBANAccountQueryKey = 'iban-account';

export const GetTransactionsQueryKey = 'get-transactions';

export const GetLogsQueryKey = 'get-logs';
export const PostCardPaymentQueryKey = 'post-card-payment';

export const CurrenciesCountQueryKey = 'currencies-count';
export const CryptoStatsQueryKey = 'crypto-stats';

export const ClientAccessQueryKey = 'client-access';
export const StaffQueryKey = 'staff';
export const NewClientPOSQueryKey = 'new-client';


//NEW FORM QWERY KEYS
export const BusinessInfoQueryKey = 'business-info';
export const BusinessInfoFilesQueryKey = 'business-info-files';
export const NaturalPersonQueryKey = 'natural-person';
export const NaturalPersonPLUSQueryKey = 'natural-person-plus';
export const QuestionaryQueryKey = 'questionary';
export const GenericStatusQueryKey = 'generic-status';
export const PaymentCheckoutQueryKey = 'payment-checkout';
export const ClientInfoQueryKey = 'client-info';

export const DepositWalletQueryKey = 'deposit-wallet';
export const ExchangeSettingsQueryKey = 'exchange-settings';

export const ListDepositWalletQueryKey = 'list-deposit-wallet';
